// plugins/fetch-timeout.client.ts
export default defineNuxtPlugin(() => {
  // Configure global fetch timeout
  const originalFetch = window.fetch;
  // Increase dev timeout to 30s to prevent unnecessary retries that slow down development
  const DEFAULT_TIMEOUT = import.meta.dev ? 30000 : 30000;
  
  window.fetch = function(input: RequestInfo | URL, init?: RequestInit) {
    // Apply an environment-aware timeout when one is not provided
    const controller = new AbortController();
    const configuredTimeout = typeof (init as any)?.timeout === 'number'
      ? Number((init as any).timeout)
      : DEFAULT_TIMEOUT;
    const timeoutId = setTimeout(() => controller.abort(), configuredTimeout);
    
    if (init?.signal && typeof AbortSignal.any !== 'function') {
      init.signal.addEventListener('abort', () => controller.abort(), { once: true });
    }

    const fetchInit: RequestInit = {
      ...init,
      signal: init?.signal && typeof AbortSignal.any === 'function'
        ? AbortSignal.any([init.signal, controller.signal])
        : controller.signal
    };
    
    return originalFetch(input, fetchInit)
      .finally(() => clearTimeout(timeoutId))
      .catch((error) => {
        if (error.name === 'AbortError') {
          throw new Error(`Request timeout after ${configuredTimeout / 1000} seconds`);
        }
        throw error;
      });
  };
});
